<!-- =========================================================================================
  File Name: SponsorEdit.vue
  Description: Sponsor Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<style scoped>
.header-custome{padding-left: 2px;}
.image-wrap-add-edit{width: 180px; height: 36px; border: 1px solid #dfdfdf; border-radius: 5px; display: flex; justify-content: center; align-items: center;overflow: hidden;}
</style>
<template>
  <div id="page-user-edit" class="attendee-form-wrap">
    <div class="header-custome">
      <h3>Add Sponsor</h3>
    </div>
    <vs-alert color="danger" title="Attendee Not Found" :active.sync="sponsor_not_found">
      <span>Sponsor record with id: {{ $route.params.sponsoreId }} not found.</span>
      <span>
        <span>Check</span>
        <router-link :to="{name:'page-user-list'}" class="text-inherit underline">All Users</router-link>
      </span>
    </vs-alert>

    <vx-card v-if="sponsor_data">
      <div slot="no-body" class="tabs-container px-6 pt-6">
        <vs-tabs position="left" v-model="activeTab" class="tab-action-btn-fill-conatiner">
          <vs-tab label="Sponsor" icon-pack="feather" icon="icon-user">
            <div class="tab-text">
              <sponsor-edit-tab-account :data="sponsor_data" />
            </div>
          </vs-tab>
          
          <!-- <vs-tab label="Social" icon-pack="feather" icon="icon-share-2">
            <div class="tab-text">
              <exhibitor-edit-tab-social class="mt-4" :data="exhibitor_data" />
            </div>
          </vs-tab> -->
        </vs-tabs>
      </div>
    </vx-card>
  </div>
</template>

<script>
import SponsorEditTabAccount from "./SponsorEditTabAccount.vue";
//import ExhibitorEditTabSocial from "./ExhibitorEditTabSocial.vue";

// Store Module
import moduleSponsorManagement from "@/store/sponsor-management/moduleSponsorManagement.js";

export default {
  components: {
    SponsorEditTabAccount,
    //ExhibitorEditTabSocial
  },
  data() {
    return {
      sponsor_data: null,
      sponsor_not_found: false,

      /*
        This property is created for fetching latest data from API when tab is changed

        Please check it's watcher
      */
      activeTab: 0
    };
  },
  watch: {
    activeTab() {
      this.fetch_sponsor_data();
    }
  },
  methods: {
    fetch_sponsor_data() {
      this.$store
        .dispatch("sponsorManagement/fetchSponsor", null)
        .then(res => {
          this.sponsor_data = res.data;
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.sponsor_not_found = true;
            return;
          }
          console.error(err);
        });
    }
  },
  created() {
    //debugger;
    // Register Module UserManagement Module
    if (!moduleSponsorManagement.isRegistered) {
      this.$store.registerModule("sponsorManagement", moduleSponsorManagement);
      moduleSponsorManagement.isRegistered = true;
    }
    this.fetch_sponsor_data(this.$route.params.sponsorId);
  }
};
</script>